// ScrollSyncedVideoStage.tsx
import { useEffect, useRef } from "react";
import gsap from "gsap";

type Props = {
  gsapTimeline: gsap.core.Timeline | null;
  label: string;        // «stage3Video»
  src?: string
};

const ScrollSyncedVideoStage: React.FC<Props> = ({ gsapTimeline, label, src = "https://assets.codepen.io/39255/output_960.mp4" }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !gsapTimeline) return;

    const init = () => {
      /** 1️⃣  Scrub del vídeo */
      video.play()
      .then(() => video.pause())   // (ignora errores de autoplay)
        .catch(() => { });
      
   
      const scrub = gsap.fromTo(
        video,
        { currentTime: 0 },
        { currentTime: video.duration, ease: "none" }
      );
      gsapTimeline.add(scrub, label);           // ← empieza en «stage3Video»
    };

   
    if (video.readyState >= 3) {        // HAVE_FUTURE_DATA
      init();
    } else {
      /** Si no, esperar al evento `canplay` */
      video.addEventListener("canplay", init, { once: true });
    }
    return () => video.removeEventListener("loadedmetadata", init);
  }, [gsapTimeline, label]);

  return (
    <div className="min-h-screen">
      <video
        ref={videoRef}
        src={src}
        playsInline
        muted
        preload="auto"
        className="fixed top-1/2 left-1/2 min-w-full min-h-full -translate-x-1/2 -translate-y-1/2 pointer-events-none special-video"
      />

    </div>
  );
};

export default ScrollSyncedVideoStage;
